<template>
    <div>

        <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                :variant="variantAlert"
                @dismiss-count-down="countDownChanged"
        >
            {{ textAlert }}
        </b-alert>
        <!--begin::Notice-->
        <b-alert
                show
                variant="light"
                class="alert alert-custom alert-white alert-shadow fade show gutter-b"
        >
            <div class="alert-icon">
                <span class="svg-icon svg-icon-lg">
                    <inline-svg src="media/svg/icons/Tools/Compass.svg" />
                </span>
            </div>
            <div class="alert-text">
                Отредактируйте информацию и нажмите кнопку "Сохранить"
            </div>
        </b-alert>
        <!--end::Notice-->

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Редактировать</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="load" class="text-center mb-10">
                            <b-spinner variant="primary" label="Text Centered"></b-spinner>
                        </div>

                            <b-form-group class="mt-0"
                                          id="input-group-1"
                                          description="Введите заголовок"
                                          label="Заголовок:"
                                          label-for="input-1"
                            >
                                <b-form-input
                                        id="input-1"
                                        v-model.trim="page.title"
                                        :class="{'is-invalid': errors.title}"
                                        required
                                        placeholder="Введите Заголовок"
                                ></b-form-input>
                                <div v-if="errors.title" class="invalid-feedback">{{errors.title[0]}}</div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          id="input-group-1"
                                          description="Введите Описание"
                                          label="Описание:"
                                          label-for="input-2"
                            >
                                <b-form-textarea
                                        id="description"
                                        placeholder="Введите Описание"
                                        v-model.trim="page.description"
                                        :class="{'is-invalid': errors.description}"
                                ></b-form-textarea>
                                <div v-if="errors.description" class="invalid-feedback">{{errors.description[0]}}</div>
                            </b-form-group>

                            <b-form-group class="mt-3"
                                          id="input-group-1"
                                          label="Контент:"
                                          label-for="input-2"
                            >

                                <ckeditor :editor="editor" v-model="page.content" :config="editorConfig"></ckeditor>
                                <div v-if="errors.content" class="invalid-feedback">{{errors.content[0]}}</div>
                            </b-form-group>

                            <b-button @click="savePage" ref="save_page" type="submit" variant="primary">Сохранить</b-button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {GET_PAGE} from "@/core/services/store/pages.module";
    import {UPDATE_PAGE} from "../../../core/services/store/pages.module";

    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import "@ckeditor/ckeditor5-build-classic/build/translations/ru"

    import UploadAdapter from "../../../uploadadapter";



    export default {
        name: "EditPage",
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Страницы сайта", route: "/pages" },
                { title: "Редактировать страницу" }
            ]);
            this.$store.dispatch(GET_PAGE, this.$route.params.id)

        },

        computed: {
            ...mapGetters({
                page: 'gettersPage',
                errors: 'errorsPage',
                load: 'getPageLoad'
            })
        },
        data() {
            return {

                editor: ClassicEditor,
                editorConfig: {
                    language: "ru",
                    extraPlugins: [this.uploader],

                },

                dismissSecs: 4,
                dismissCountDown: 0,
                showDismissibleAlert: false,
                variantAlert: '',
                textAlert: '',
            }
        },

        methods:{

            uploader(editor)
            {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },


            savePage(){

                const submitButton = this.$refs["save_page"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");


                const id = this.page.id;

                const page = {
                    title: this.page.title,
                    description: this.page.description,
                    content: this.page.content
                };

                this.$store.dispatch(UPDATE_PAGE, {id, page})
                    .then(() => {
                        this.showAlert('Изменения успешно сохранены', 'success');
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger');
                        }
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });


            },


            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            showAlert(text, variant) {
                this.variantAlert = variant;
                this.dismissCountDown = this.dismissSecs;
                this.textAlert = text
            },
        }
    }
</script>

<style scoped>

</style>